import _ from 'lodash';
import GatewayService from '../GatewayService.js';
import { missingParam } from '../errors.js';
import log from '../log.js';
import axios from '../axios.js';
var lmsMappingService = new GatewayService('lms-mapping-svc');
var externalAppGrantService = new GatewayService('external-app-grant-svc');

var pingLmsMappingService = function pingLmsMappingService() {
  return lmsMappingService.get('liveops/ping');
};

var getLmsMappingServiceStatus = function getLmsMappingServiceStatus() {
  return lmsMappingService.get('liveops/status');
};

var getLmsMappingServiceVersion = function getLmsMappingServiceVersion() {
  return lmsMappingService.get('liveops/version');
};

var getUserContexts = function getUserContexts(userKey) {
  if (_.isEmpty(userKey)) {
    log.error('Cannot fetch context because userKey was not specified');
    return Promise.reject(missingParam('userKey'));
  }

  return lmsMappingService.get("v1/users/".concat(userKey, "/contexts"));
};

var checkUserGrantAuthStatus = function checkUserGrantAuthStatus(userKey) {
  if (_.isEmpty(userKey)) {
    log.error('Cannot check auth grants because userKey was not specified');
    return Promise.reject(missingParam('userKey'));
  }

  return lmsMappingService.get("v1/users/".concat(userKey, "/grants"));
};
/* eslint-disable camelcase */


var followAuthorizeUrl = function followAuthorizeUrl(authorize_url) {
  if (_.isEmpty(authorize_url)) {
    log.error('Cannot follow authorize url because authorize_url was not specified');
    return Promise.reject(missingParam('authorize_url'));
  }

  return axios.get(authorize_url);
};
/* eslint-enable camelcase */


var resetUserSchoologyGrants = function resetUserSchoologyGrants(userKey) {
  var SCHOOLOGY_LMS_ID = '1869071044::fd3faa0c2f55aa21a1d7f6f1d50209cd';
  var SCHOOLOGY_APP_ID = '2990065923';
  var queryParams = "?user_bk=".concat(userKey, "&app_id=").concat(SCHOOLOGY_APP_ID);
  return externalAppGrantService.get("v1/lms/".concat(SCHOOLOGY_LMS_ID, "/oauth1/request_authorization").concat(queryParams));
};

export default {
  pingLmsMappingService: pingLmsMappingService,
  getLmsMappingServiceStatus: getLmsMappingServiceStatus,
  getLmsMappingServiceVersion: getLmsMappingServiceVersion,
  getUserContexts: getUserContexts,
  checkUserGrantAuthStatus: checkUserGrantAuthStatus,
  followAuthorizeUrl: followAuthorizeUrl,
  resetUserSchoologyGrants: resetUserSchoologyGrants
};